import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAll as getActivityResponseData } from 'actions/activity-analytics';
import { store } from 'redux-rest-reducer';
import { Checkbox, Label } from 'semantic-ui-react';
import Plot from 'react-plotly.js';
import _ from 'lodash';
import { aggregateItemResponses } from './utils/data-compare';
import ActivityAggregationTable from './table-analytics';
import { q50, q25, q75 } from './utils/data-compare';
import { SCORE_COLOR, TIME_COLOR } from 'constants/plot-constants';

export class ActivityAnalytics extends PureComponent {
  constructor() {
    super();
    this.state = {
      xAxisData: null,
      activityResponseData: null,
      activityItemData: null,
      itemList: null,
      aggregatedDict: null,
      toggleTimeData: false,
    };
  }

  static getDerivedStateFromProps({ itemResponses, activityId }) {
    if (itemResponses) {
      let newState = {};
      const activityResponsesData = store.getAll(itemResponses, activityId);
      if (activityResponsesData && activityResponsesData.data) {
        newState['activityResponseData'] = activityResponsesData.data.item_response;
        newState['activityItemData'] = activityResponsesData.data.item;
        const { aggregateDict, itemList, xAxisData } = aggregateItemResponses(
          activityResponsesData.data.item,
          activityResponsesData.data.item_response,
        );
        newState['aggregateDict'] = aggregateDict;
        newState['itemList'] = itemList;
        newState['xAxisData'] = xAxisData;
      }
      if (newState !== {}) {
        return newState;
      }
    }
    return null;
  }

  componentDidMount() {
    const { activityId } = this.props;
    const { getActivityResponseData } = this.props.actions;
    getActivityResponseData(activityId);
  }

  toggleTimeCheckbox = () =>
    this.setState(prevState => ({ toggleTimeData: !prevState.toggleTimeData }));

  getData = () => {
    const { toggleTimeData, xAxisData } = this.state;
    //console.log('toggleTimeData', toggleTimeData)
    const {
      scoreData,
      timeData,
      lineData,
      q1ScoreData,
      q3ScoreData,
      q1TimeData,
      q3TimeData,
    } = this.getPlotData();
    //console.log('responseData', responseData)
    let data = [
      {
        x: xAxisData,
        y: toggleTimeData ? timeData : scoreData,
        type: 'bar',
        name: toggleTimeData ? 'TimeData' : 'ScoreData',
        mode: 'lines + percent',
        tickfont: { color: 'rgb(148, 103, 189)' },
        marker: {
          color: toggleTimeData ? TIME_COLOR : SCORE_COLOR,
        },
      },
      {
        x: xAxisData,
        y: toggleTimeData ? q3TimeData : q1ScoreData,
        mode: 'line+markers',
        name: 'Bottom 25% Quartile',
        fill: toggleTimeData ? 'tonexty' : 'tozeroy',
        type: 'scatter',
        tickfont: { color: 'rgba(0,0,0,0.89)' },
        visible: 'legendonly',
      },
      {
        x: xAxisData,
        y: toggleTimeData ? q1TimeData : q3ScoreData,
        mode: 'line+markers',
        name: 'Top 25% Quartile',
        fill: toggleTimeData ? 'tozeroy' : 'tonexty',
        type: 'scatter',
        tickfont: { color: 'rgb(172, 34, 34, 0.08)' },
        visible: 'legendonly',
      },
    ];
    if (!toggleTimeData) {
      data.push({
        x: xAxisData,
        y: lineData,
        yaxis: 'y2',
        name: 'Attempts',
        type: 'scatter',
        mode: 'lines + Marker',
        marker: { color: lineData ? '#191919' : 'rgba(10,200,10,0.2)' },
      });
      data.push({
        x: xAxisData,
        y: toggleTimeData ? timeData : q1ScoreData,
        mode: 'line+markers',
        name: 'Median Score',
        fill: 'tonexty',
        type: 'scatter',
        tickfont: { color: 'rgba(0,0,0,0.89)' },
        visible: 'legendonly',
      });
    }
    return data;
  };

  getPlotData() {
    const { aggregateDict, itemList } = this.state;
    let lineData = itemList.map(item_id => {
      let mean_avg_attempts =
        _.sum(Object.values(aggregateDict[item_id]['avg_attempts'])) /
        Object.values(aggregateDict[item_id]['avg_attempts']).length;
      return mean_avg_attempts;
      //console.log("num_attempted",num_attempted)
    });
    let scoreData = itemList.map(item_id => {
      return (
        _.sum(Object.values(aggregateDict[item_id]['accuracy'])) /
        Object.values(aggregateDict[item_id]['accuracy']).length
      );
    });
    let medianScoreData = itemList.map(item_id => {
      return (
        _.sum(Object.values(aggregateDict[item_id]['accuracy'])) /
        Object.values(aggregateDict[item_id]['accuracy']).length
      );
    });
    let q1ScoreData = itemList.map(item_id => {
      return q25(Object.values(aggregateDict[item_id]['accuracy']));
    });
    let q3ScoreData = itemList.map(item_id => {
      return q75(Object.values(aggregateDict[item_id]['accuracy']));
    });
    let timeData = itemList.map(item_id => {
      return q50(Object.values(aggregateDict[item_id]['time'])) / 60.0;
    });
    let q1TimeData = itemList.map(item_id => {
      return q25(Object.values(aggregateDict[item_id]['time'])) / 60.0;
    });
    let q3TimeData = itemList.map(item_id => {
      return q75(Object.values(aggregateDict[item_id]['time'])) / 60.0;
    });
    return {
      scoreData,
      timeData,
      lineData,
      q1ScoreData,
      q3ScoreData,
      q1TimeData,
      q3TimeData,
      medianScoreData,
    };
  }

  render() {
    const { activityId } = this.props;
    const { toggleTimeData, aggregateDict } = this.state;
    return (
      <Fragment>
        <tr />
        <Label>
          {' '}
          Score <Checkbox toggle onChange={this.toggleTimeCheckbox} /> Time{' '}
        </Label>
        {aggregateDict && (
          <Plot
            data={this.getData()}
            layout={{
              width: 1000,
              height: 500,
              title: ''.concat(
                activityId.split('_')[activityId.split('_').length - 1],
                toggleTimeData ? ' Time(minutes) Plot' : ' Accuracy plot',
              ),
              hoverlabel: { bgcolor: '#FFF' },
              yaxis: {
                title: toggleTimeData ? 'Time(minutes)' : 'Accuracy',
                range: toggleTimeData ? [1, 100] : [0, 1],
                autorange: toggleTimeData,
                tickformat: toggleTimeData ? '.0' : ',.0%',
              },
              yaxis2: {
                title: '# Avg Attempts',
                marker: { color: '#7f7f7f' },

                titlefont: { color: '#7f7f7f' },
                tickfont: { color: '#7f7f7f' },
                overlaying: 'y',
                side: 'right',
                range: [1, 2],
              },
            }}
          />
        )}
        <ActivityAggregationTable data={aggregateDict} />
      </Fragment>
    );
  }
}

export default connect(
  ({ itemResponses }, { match: { params: { activityId } } = {} }) => ({
    itemResponses: itemResponses,
    activityId: activityId,
  }),
  dispatch => ({
    actions: bindActionCreators({ getActivityResponseData }, dispatch),
  }),
)(ActivityAnalytics);
